export default "__VITE_ASSET__38c5f92a__"